//
// Generated class LedgerAccount
//

/// <reference path="LedgerAccount_ManagedObject.ts" />

enum LedgerAccountType
{
    debit = 0,
    credit = 1
}

class LedgerAccount extends LedgerAccount_ManagedObject
{
    get description():string {
        return this.name + " (" + this.prefix + ")"
    }

    set normalizedAccountPrefix(value:string){
        let v = value.trim();
        let components = v.split('.');
        if (components.length == 1) { this.prefix = v; return; }

        let last = components[components.length - 1];
        let number = parseInt(last) ?? 0;
        components.pop();
        this.prefix = components.join('.') + '.' + number;
    }

    // Natural-sort key for `prefix`. Zero-pads numeric segments so that
    // "400.0.2" sorts before "400.0.10" instead of after it.
    get sortPrefix():string {
        let p = this.prefix;
        if (p == null) return "";
        let parts = p.split('.');
        let out:string[] = [];
        for (let i = 0; i < parts.length; i++) {
            let seg = parts[i];
            if (/^[0-9]+$/.test(seg)) {
                let pad = "";
                for (let j = seg.length; j < 12; j++) pad += "0";
                out.push(pad + seg);
            }
            else out.push(seg);
        }
        return out.join('.');
    }
}
